// Step 1: 区域选择 — Apple 浅色风格
import { Check } from 'lucide-react';

/** 销售区域数据 */
const REGIONS = [
  { id: 'china', name: '中国区', nameEn: 'China', count: 315, emoji: '🇨🇳' },
  { id: 'north_america', name: '北美区', nameEn: 'North America', count: 230, emoji: '🇺🇸' },
  { id: 'northwest_europe', name: '西北欧区', nameEn: 'NW Europe', count: 195, emoji: '🇪🇺' },
  { id: 'southeast_europe', name: '东南欧区', nameEn: 'SE Europe', count: 180, emoji: '🇪🇺' },
  { id: 'middle_east_africa', name: '中东非区', nameEn: 'MEA', count: 148, emoji: '🌍' },
  { id: 'east_asia', name: '东亚区', nameEn: 'East Asia', count: 112, emoji: '🇯🇵' },
  { id: 'south_asia', name: '南亚区', nameEn: 'South Asia', count: 105, emoji: '🇮🇳' },
  { id: 'south_america', name: '南美区', nameEn: 'South America', count: 87, emoji: '🇧🇷' },
  { id: 'russia', name: '俄语区', nameEn: 'Russia & CIS', count: 64, emoji: '🇷🇺' },
  { id: 'non_certified', name: '非认证地区', nameEn: 'Non-Certified', count: 52, emoji: '🌐' },
] as const;

export type RegionId = typeof REGIONS[number]['id'];

interface RegionStepProps {
  selectedRegion: RegionId | null;
  onSelect: (region: RegionId) => void;
}

export function RegionStep({ selectedRegion, onSelect }: RegionStepProps) {
  return (
    <div className="animate-in fade-in-0 duration-500">

      {/* 区域卡片网格 */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 max-w-4xl mx-auto">
        {REGIONS.map((region, index) => {
          const isSelected = selectedRegion === region.id;
          return (
            <button
              key={region.id}
              onClick={() => onSelect(region.id)}
              className={`
                group relative flex flex-col items-center p-5 rounded-2xl border transition-all duration-300
                ${isSelected
                  ? 'border-[#0071e3] bg-[#0071e3]/[0.04] shadow-[0_0_0_1px_#0071e3]'
                  : 'border-gray-200/80 bg-white hover:border-gray-300 hover:shadow-md'
                }
              `}
              style={{
                animationDelay: `${index * 50}ms`,
                animationFillMode: 'both',
              }}
            >
              {/* 选中标记 */}
              {isSelected && (
                <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-[#0071e3] flex items-center justify-center">
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </div>
              )}

              {/* Emoji 国旗 */}
              <span className="text-3xl mb-2">{region.emoji}</span>

              {/* 区域名称 */}
              <span className={`text-[15px] font-medium tracking-tight ${
                isSelected ? 'text-[#0071e3]' : 'text-[#1d1d1f]'
              }`}>
                {region.name}
              </span>

              {/* 英文名 */}
              <span className="text-[11px] text-[#86868b] mt-0.5">
                {region.nameEn}
              </span>

              {/* 产品数量 */}
              <span className={`mt-2 text-[12px] px-2 py-0.5 rounded-full ${
                isSelected
                  ? 'bg-[#0071e3]/10 text-[#0071e3]'
                  : 'bg-gray-100 text-[#86868b]'
              }`}>
                {region.count} 款产品
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { REGIONS };
export default RegionStep;
